'use strict';
var template = require('./template'),
    constants = require('../constants');

function cssModelUsing(height, width, tagLineHeight) {
    var dynamicCssModel, h, w, totalH;
    tagLineHeight = tagLineHeight || 0;
    totalH = parseFloat(height);
    h = totalH - tagLineHeight;
    w = parseFloat(width);
    dynamicCssModel = {
        width: w,
        height: totalH,
        logoWidth: h,
        logoHeight: h - 2,
        logo_imgWidth: h - 1 - 2 * Math.floor((h - 6) / 6),
        logo_imgHeight: h - 1 - 2 * Math.floor((h - 6) / 6),
        logo_marginTop: Math.floor((h - 6) / 6),
        contentHeight: Math.floor((h + 8) / 2),
        contentFontSize: Math.floor((h + 36) / 6),
        contentLineHeight: Math.floor((h + 8) / 2),
        contentPaddingTop: Math.floor((h - 8) / 4) - 1,
        contentPaddingRight: Math.floor((5 * h + 24) / 18),
        contentPaddingBottom: h - Math.floor((h + 8) / 2) - Math.floor((h - 8) / 4) - 1,
        contentPaddingLeft: Math.floor((5 * h + 24) / 18),
        contentMinWidth: 0,
        content_imgWidth: Math.floor((11 * h + 96) / 6),
        content_imgHeight: Math.floor((h + 8) / 2),
        content_imgMarginTop: Math.floor((h + 8) / 20),
        content_imgMarginLeft: Math.floor((h + 8) / 20)
    };
    return dynamicCssModel;
}

function generateCssUsing(cssModel) {
    return template('dynamic', cssModel);
}

function longestIndexFirst(arr) {
    var indexes = [],
        i;
    for (i = 0; i < arr.length; i += 1) {
        indexes[i] = i;
    }
    indexes.sort(function reverseLengthSort(a, b) {
        return (arr[b].length - arr[a].length) || (b - a);
    });
    return indexes;
}

function magicTrimmer(symbol, limit, text) {
    var tokens = text && text.split(symbol),
        total = 0,
        removeCount, i, tIdx, trimOrder, amtToRemove;
    total = 0;
    for (i = 0; i < tokens.length; i += 1) {
        total += tokens[i].length;
    }
    removeCount = Math.max(0, total - limit);
    trimOrder = longestIndexFirst(tokens);
    for (i = 0; i < trimOrder.length; i += 1) {
        tIdx = trimOrder[i];
        amtToRemove = Math.min(removeCount, tokens[tIdx].length);
        tokens[tIdx] = tokens[tIdx].slice(0, tokens[tIdx].length - amtToRemove);
        removeCount -= amtToRemove;
    }
    return tokens.join(symbol);
}
module.exports = {
    cssModelUsing: cssModelUsing,
    generateCssUsing: generateCssUsing,
    magicTrimmer: magicTrimmer
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/util/dynamic.js
 ** module id = 8
 ** module chunks = 0
 **/